import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Loading, Toast, FormGroup, Checkbox, Divider, Button} from "spectre-react/dist/cjs";
import WagesParamsForm from "../WagesParamsEditPage/WagesParamsForm";
import {fetchWagesParamsLast, fetchWagesTestParams, postWagesTestParams} from "../../api";
import {setWagesParamsSelectionModeEnabled} from "../../store/actions";
import {Redirect} from "react-router-dom";
import {SETTINGS_PATH} from "../../paths";


class WagesTestParamsEditPage extends React.Component {
    static propTypes = {
        isSelectionModeEnabled: PropTypes.bool,
        setModeEnabled: PropTypes.func.isRequired,
    }

    state = {
        fetchState: 0, fetchError: undefined,
        submitState: 0, submitError: undefined,
        testParams: undefined,
        actualParams: undefined, actualParamsStartDate: undefined,
    }

    _paramsFormController = undefined;
    receiveController = (controller) => this._paramsFormController = controller;

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        this.setState({fetchState: 1, fetchError: undefined});

        try {
            const {doc: {params: actualParams, startDate: actualParamsStartDate}} = await fetchWagesParamsLast()
            const {params: testParams} = await fetchWagesTestParams();
            this.setState({fetchState: 2, testParams, actualParams, actualParamsStartDate});
        } catch (error) {
            console.error(error);
            this.setState({fetchState: 0, fetchError: error.message});
        }
    }

    onSubmit = async () => {
        const {params} = this._paramsFormController.getParams();

        this.setState({submitState: 1, submitError: undefined});

        try {
            await postWagesTestParams(params);
            this.setState({submitState: 2});
        } catch (error) {
            console.error(error);
            this.setState({submitState: 0, submitError: error.message});
        }
    }

    onCheckboxChange = (ev) => {
        this.props.setModeEnabled(ev.target.checked);
    }

    render() {
        const {
            fetchState, fetchError,
            submitState, submitError,
            actualParams, actualParamsStartDate,
            testParams,
        } = this.state;

        const { isSelectionModeEnabled, } = this.props;

        if (submitState === 2)
            return <Redirect to={SETTINGS_PATH} />;

        if (fetchError)
            return <Toast error>{fetchError}</Toast>;

        if (fetchState !== 2)
            return <Loading large/>;

        const isLoading = fetchState === 1 && submitState === 1;

        return (
            <div>
                <div className="h2">Режим подбора коэффициентов</div>

                <Divider />

                <div className="my-6 form-input-hint text-primary">
                    <p>При включении режима расчеты будут производиться 1) при открытии страниц каждый раз заново, а не загружаться из базы данных; 2) с этим набором коэффициентов, расположенным ниже.</p>
                    <p>Коэффициенты хранятся в базе данных и являются общими для всех пользователей (предполагается, что коэффициенты подбирает один человек), однако значение чекбокса хранится в браузере. Таким образом, включение этого режима не влияет на остальных пользователей, они будут видеть ту же информацию, что и прежде.</p>
                    <p>Эта страница доступна только администраторам. При выключенном режиме отображаются последние актуальные коэффициенты в режиме read-only.</p>
                </div>

                <FormGroup className="my-4 mb-6 d-flex flex-centered bg-light-aqua border-y">
                    <Checkbox switch large id="selectRange" checked={isSelectionModeEnabled} onChange={this.onCheckboxChange}>
                        ВКЛЮЧИТЬ РЕЖИМ
                    </Checkbox>
                </FormGroup>

                {isSelectionModeEnabled && <WagesParamsForm key="test" calcParams={testParams} disableStartDateInput provideController={this.receiveController} />}
                {!isSelectionModeEnabled && <WagesParamsForm key="actual" calcParams={actualParams} startDate={actualParamsStartDate} readOnly />}

                <Divider />

                <div>
                    {submitError && <Toast error className="my-2">{submitError}</Toast>}

                    <Button primary loading={isLoading} onClick={this.onSubmit} disabled={!isSelectionModeEnabled}>Отправить</Button>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    const isSelectionModeEnabled = state.wagesParamsSelectionModeEnabled;
    return {isSelectionModeEnabled};
};


const mapDispatchToProps = (dispatch, ownProps) => ({
    setModeEnabled: (flag) => dispatch(setWagesParamsSelectionModeEnabled(flag))
});


export default connect(mapStateToProps, mapDispatchToProps)(WagesTestParamsEditPage);